module.exports = __webpack_public_path__ + "../resources/img/icReInfo.9e302f77.svg";